import { all } from 'redux-saga/effects';
import system from './system';
import user from './user';
import mt from './mt';
import sales from './sales';
import notice from './notice';

export default function* (): any {
    yield all([
        ...system,
        ...user,
        ...mt,
        ...sales,
        ...notice
    ]);
}
